import messageService from 'services/message.service';

const state = {
    messages: [],
    messagesInfo: [],
    loading: false,
    isEmptyMessages: true,
    filter: {
        claim: '',
        status: null,
        sort: null
    }
};

const mutations = {
    setRead(state, messageId) {
        const message = state.messages.find(message => message.ChatInc == messageId);
        if (message) {
            message.ChatIsRead = 1;
        }
    },
    setMessages(state, messages) {
        state.messages = messages;
    },
    setMessagesInfo(state, messagesInfo) {
        state.messagesInfo = messagesInfo;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setIsEmptyMessages(state, isEmpty) {
        state.isEmptyMessages = isEmpty;
    },
    addFirstMessage(state, message) {
        state.messages.unshift(message);
    }
};

const actions = {
    clearResult ({ commit }) {
        commit('setMessages', []);
    },
    getMessages({ commit }, params) {
        commit('setLoading', true);
        return messageService.getMessages(params).then(response => {
            const messages = response[0];
            const messagesInfo = response[1][0];

            commit('setMessages', messages);
            commit('setMessagesInfo', messagesInfo);
            commit('setIsEmptyMessages', !messages.length);
            commit('setLoading', false);
        }).catch(() => {
            commit('setLoading', false);
        });
    },
    loadMore({ commit, state }, params) {
        return new Promise((resolve, reject) => {
            messageService.getMessages(params).then(response => {
                const messages = response[0];
                const combinedMessages = state.messages.concat(messages);

                commit('setMessages', combinedMessages);
                commit('setIsEmptyMessages', combinedMessages.length === 0);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    },
    async sendMessage({ commit }, params) {
        return new Promise((resolve, reject) => {
            messageService.sendMessage(params)
                .then((messageResponse) => {
                    const newMessage = {
                        ChatClaim: params.claim,
                        ChatEdate: new Date().toISOString(),
                        ChatText: params.message,
                    };
                    commit('addFirstMessage', newMessage);
                    resolve(messageResponse);
                })
                .catch((error) => {
                    console.error('Error sending message:', error);
                    reject(error);
                });
        });
    },
    setRead({ commit }, params) {
        return new Promise((resolve, reject) => {
            messageService.setRead(params)
                .then((response) => {
                    commit('setRead', params.chat_id);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    atFirstMessage({ commit, state }, message) {
        commit('setMessages', [message, ...state.messages]);
    }
};

const getters = {
    messages: state => state.messages,
    loading: state => state.loading,
    isEmptyMessages: state => state.isEmptyMessages,
    messagesInfo: state => state.messagesInfo
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
